import { cn } from '@/lib/utils';

interface CreatorMvpNoteProps {
  className?: string;
}

export function CreatorMvpNote({ className }: CreatorMvpNoteProps) {
  return (
    <div className={cn('rounded-md border bg-muted/30 px-3 py-2 text-sm', className)}>
      <span className="font-medium">Admin note:</span>{' '}
      <span className="text-muted-foreground">
        Creator and public frontend flows are hidden from the app/user frontend for the
        predictions MVP. These controls are kept here for setup and review work, and the public
        flows will be reintroduced later.
      </span>
    </div>
  );
}
